import locale from "@bonliva-crm/locale";
import { ConsultantPipelineStatus } from "@bonliva-crm/shared";

export function getStatus(status: string): LabelValue | null {
  return {
    label: locale.consultantPipelineBoardHeaders[status] || status,
    value: status
  };
}

export function getStatuses() {
  return Object.keys(ConsultantPipelineStatus).map((status) => {
    return {
      label: locale.consultantPipelineBoardHeaders[status] || status,
      value: status
    };
  });
}
